module.exports = __webpack_public_path__ + "static/media/2.64c7e0e1.png";